import React, { useEffect, useState } from "react";

/**
 * 브라우저가 오프라인 상태일 때 상단에 배너를 표시합니다.
 * navigator.onLine + online/offline 이벤트를 사용하며 SSR-safe합니다.
 */
export function OfflineBanner() {
  const [offline, setOffline] = useState(
    typeof navigator !== "undefined" ? !navigator.onLine : false,
  );

  useEffect(() => {
    const onOnline = () => setOffline(false);
    const onOffline = () => setOffline(true);
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      role="alert"
      aria-live="assertive"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        padding: "8px 16px",
        background: "#bd852f",
        color: "#ffffff",
        font: "600 13px var(--aw-font, system-ui)",
        letterSpacing: "0.01em",
      }}
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path
          d="M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2zm0 3.5v3m0 1.5v1"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
      오프라인 — 네트워크 연결을 확인하세요
    </div>
  );
}
